import firebase from 'firebase/app';
import 'firebase/firestore';

let inactivityTimer;
const INACTIVITY_TIME = 5 * 60 * 1000; // 5 minutes in milliseconds

// Function to track user activity
async function trackUserActivity(user, role) {
  if (!user || !role) {
    console.error('User or role is missing. Cannot track activity.');
    return;
  }
  if (role === 'admin') {
    return;
  }
  const collectionName = role === 'student' ? 'students' : 'tutors';

  const now = Date.now();

  try {
    const formattedTime = new Date(now).toUTCString(); // Format the time as a string

    const userDocRef = firebase
      .firestore()
      .collection(collectionName)
      .doc(user.uid);
    const userDoc = await userDocRef.get();

    if (userDoc.exists) {
      const lastActive = userDoc.data().lastActive;
      if (lastActive && new Date(lastActive).getTime() === now) {
        console.log('Activity already logged for the current timestamp.');
        return;
      }
    }

    await userDocRef.set(
      {
        lastActive: formattedTime
      },
      { merge: true }
    );
    console.log('User activity tracked successfully');
  } catch (error) {
    console.error('Error tracking user activity:', error);
  }
}

// Function to initialize user activity tracking
function initializeUserActivityTracking(auth) {
  if (!auth || !auth.user || !auth.role) {
    console.error(
      'Auth object, user, or role is missing. Cannot initialize tracking.'
    );
    return;
  }

  // Track activity on initialization
  trackUserActivity(auth.user, auth.role);

  // Reset inactivity timer on user activity
  const resetInactivityTimer = () => {
    clearTimeout(inactivityTimer);
    inactivityTimer = setTimeout(() => {
      trackUserActivity(auth.user, auth.role);
    }, INACTIVITY_TIME);
  };

  // Add event listeners for user activity
  ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'].forEach((event) => {
    window.addEventListener(event, resetInactivityTimer);
  });

  // Start the inactivity timer
  resetInactivityTimer();
}

export { initializeUserActivityTracking };
